function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { memo } from 'react';
import PropTypes from 'prop-types';
import useThemeProps from "../../hooks/useThemeProps";

function SvgFourthSquareOutlinedIcon(props) {
  var c = useThemeProps();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    width: props.size || '1em',
    height: props.size || '1em'
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.151 4.679v.18c-.234.043-.411.118-.532.225-.172.16-.325.404-.459.733L9.85 11.45h-.18L7.19 5.743c-.128-.293-.217-.472-.27-.537a.826.826 0 0 0-.302-.234 1.325 1.325 0 0 0-.478-.112v-.181h2.705v.18c-.306.03-.505.082-.596.157a.356.356 0 0 0-.137.288c0 .163.075.417.225.762l1.684 3.881 1.563-3.833c.153-.377.23-.64.23-.786 0-.094-.048-.184-.142-.268-.095-.088-.254-.15-.479-.186a3.046 3.046 0 0 0-.083-.014v-.181h2.041ZM5.808 11.12v.18H2.97v-.18h.234c.274 0 .472-.08.596-.24.078-.104.117-.355.117-.752V5.851c0-.336-.021-.557-.064-.664a.44.44 0 0 0-.2-.21.925.925 0 0 0-.449-.117h-.234v-.181h2.837v.18h-.24c-.27 0-.467.08-.59.24-.082.104-.123.355-.123.752v4.277c0 .335.022.557.064.664.033.082.1.152.205.21.14.078.288.117.444.117h.24Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 1H2v14h12V1ZM2 0a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H2Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }));
}

SvgFourthSquareOutlinedIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
var Memo = /*#__PURE__*/memo(SvgFourthSquareOutlinedIcon);
export default Memo;